/* C3: a fixed face, cream-bound treatment and a cloth-driven reveal. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = [...document.querySelectorAll('.mv22-scene')];
  const jobs = new WeakMap();
  const epochs = new WeakMap();
  const phaseNames = ['Chin hair before treatment', 'Cream coats the chin hair', 'Hair softens in the cream', 'A cloth collects cream and hair', 'The treated chin is smooth'];
  const clamp = value => Math.max(0, Math.min(1, value));
  const ease = value => { const t = clamp(value); return t*t*(3-2*t); };
  const cancel = scene => {
    cancelAnimationFrame(jobs.get(scene));
    epochs.set(scene, (epochs.get(scene) || 0) + 1);
    scene.classList.remove('is-playing');
  };
  const render = (scene, phase, apply, softened, wipe, cloth) => {
    const x = -110 + wipe*182;
    // Reveal stays inside the opaque towel. It never leads the cloth edge.
    const edge = wipe === 0 ? 0 : wipe === 1 ? 100 : Math.max(0, Math.min(100, x + 86));
    scene.style.setProperty('--apply', (apply*118) + '%');
    scene.style.setProperty('--softened', softened);
    scene.style.setProperty('--wipe-edge', edge + '%');
    scene.style.setProperty('--cloth-x', x + '%');
    scene.style.setProperty('--cloth-visible', cloth ? 1 : 0);
    if (scene.dataset.phase !== String(phase)) {
      scene.dataset.phase = String(phase);
      scene.setAttribute('aria-label', phaseNames[phase] + '. Illustrated cosmetic sequence; timing condensed.');
      const step = [0,0,1,2,3][phase];
      scene.closest('.mv22-film').querySelectorAll('[data-step]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.step) === step)));
    }
  };
  const still = (scene, phase) => {
    cancel(scene);
    render(scene, phase, phase > 0 ? 1 : 0, phase >= 2 ? 1 : 0, phase === 3 ? .68 : phase === 4 ? 1 : 0, phase === 3);
  };
  const ready = async scene => {
    const images = [...scene.querySelectorAll('img')];
    await Promise.all(images.map(img => img.decode().catch(() => null)));
    return images.every(img => img.naturalWidth > 0);
  };
  const run = async (scene, mode = 'all') => {
    cancel(scene);
    const epoch = epochs.get(scene);
    if (reduced.matches || document.hidden) { still(scene, mode === 'apply' ? 2 : 4); return; }
    if (!await ready(scene) || epoch !== epochs.get(scene)) return;
    scene.classList.add('is-playing');
    let started;
    const tick = now => {
      if (epoch !== epochs.get(scene)) return;
      if (started === undefined) started = now;
      const elapsed = now - started;
      if (mode === 'apply') {
        render(scene, elapsed < 700 ? 1 : 2, 1, ease((elapsed-700)/620), 0, false);
        if (elapsed >= 1320) { still(scene, 2); return; }
      } else {
        const applying = ease((elapsed-580)/370);
        const softened = ease((elapsed-1240)/580);
        const wipe = ease((elapsed-1950)/930);
        const phase = elapsed < 580 ? 0 : elapsed < 1240 ? 1 : elapsed < 1950 ? 2 : elapsed < 2880 ? 3 : 4;
        render(scene, phase, applying, softened, wipe, elapsed >= 1950 && elapsed < 2880);
        if (elapsed >= 4500) { still(scene, 4); return; }
      }
      jobs.set(scene, requestAnimationFrame(tick));
    };
    jobs.set(scene, requestAnimationFrame(tick));
  };
  const inspect = (scene, phase) => {
    scene.dataset.userSelected = 'true';
    still(scene, phase);
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const scene = entry.target;
      const inView = entry.isIntersecting && entry.intersectionRatio >= .3;
      const wasInView = scene.dataset.inView === 'true';
      scene.dataset.inView = String(inView);
      if (inView && !wasInView && scene.dataset.userSelected !== 'true') run(scene);
      else if (!inView && wasInView) cancel(scene);
    });
    document.body.classList.toggle('mv22-in-view', scenes.some(scene => scene.dataset.inView === 'true'));
  }, { threshold: [0,.3] });
  scenes.forEach(scene => { still(scene, reduced.matches ? 4 : 0); observer.observe(scene); });
  document.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => inspect(document.getElementById(button.dataset.scene), [1,2,3,4][Number(button.dataset.step)])));
  document.querySelectorAll('.mv22-replay').forEach(button => button.addEventListener('click', () => {
    const scene = document.getElementById(button.dataset.scene);
    scene.dataset.userSelected = 'false';
    run(scene);
  }));
  document.querySelectorAll('.mv22-step').forEach((detail, i) => detail.addEventListener('toggle', () => {
    if (!detail.open) return;
    const section = detail.closest('.mv22-section');
    section.querySelectorAll('.mv22-step').forEach(other => { if (other !== detail) other.open = false; });
    const scene = section.querySelector('.mv22-scene');
    scene.dataset.userSelected = 'true';
    still(scene, [1,2,1,4][i%4]);
  }));
  const sync = () => scenes.forEach(scene => {
    if (document.hidden || reduced.matches) still(scene, 4);
    else if (scene.dataset.inView === 'true' && scene.dataset.userSelected !== 'true') run(scene);
  });
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
})();
